import { useCallback, useMemo } from 'react'
import { AccountIcon } from '@velasca/icons/account'
import { ChatIcon } from '@velasca/icons/chat'
import { PhoneIcon } from '@velasca/icons/phone'
import { WhatsappIcon } from '@velasca/icons/whatsapp'
import type { LiquidLink, MenuItem } from '@velasca/types'
import { SWITCH_COUNTRY_PLACEHOLDER } from '../MobileNavigation'
import {
  Link,
  LowerMenuIconWrapper,
  LowerMenuListItem,
  LowerMenuTitle,
} from '../MobileNavigation.styles'

interface LowerMenuItemProps {
  item: MenuItem
  liquidLinks?: LiquidLink[]
}

export const LowerMenuItem = ({ item, liquidLinks }: LowerMenuItemProps) => {
  const liquidLink = liquidLinks?.find((link) => link.placeholder === item.url)

  const url = liquidLink ? liquidLink.value : item.url

  const icon = useMemo(() => {
    switch (item.url) {
      case '/account': {
        return <AccountIcon />
      }
      case '#liquid-whatsapp': {
        return <WhatsappIcon />
      }
      case '#phone-number': {
        return <PhoneIcon />
      }
      case '#live-chat': {
        return <ChatIcon />
      }
      default: {
        return null
      }
    }
  }, [item.url])

  const handleLinkClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (item.url === '#live-chat') {
        e.preventDefault()
        if (window && window.zE) {
          window.zE('webWidget', 'open')
        }
      }
    },
    [item.url],
  )

  if (item.url === SWITCH_COUNTRY_PLACEHOLDER) {
    return null
  }

  return (
    <LowerMenuListItem>
      <Link
        href={url}
        target={item.isTargetBlank ? '_blank' : '_self'}
        onClick={handleLinkClick}
      >
        <LowerMenuTitle>
          <LowerMenuIconWrapper>{icon}</LowerMenuIconWrapper>
          <span className="text">{item.title}</span>
        </LowerMenuTitle>
      </Link>
    </LowerMenuListItem>
  )
}
